module.exports = __webpack_public_path__ + "static/media/how-to-pin-illustration.19a66c83.gif";